import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';
import { TenderBlockSize } from 'src/models/procurements/Tender/types';
import styles from './index.module.scss';
import Heading from '../Heading';
import { IIcon } from 'src/types/icon';

interface IProps {
  title: string;
  children: ReactNode;
  desc?: ReactNode;
  order?: number;
  size?: TenderBlockSize;
  icon?: IIcon;
  actions?: ReactNode;
  className?: string;
}
export const Section: FC<IProps> = ({
  title,
  desc,
  order = 0,
  size = TenderBlockSize.Full,
  icon,
  children,
  actions,
  className
}) => {
  return (
    <section className={classNames(styles.section, styles[size])} style={{ order }}>
      <Heading title={title} icon={icon} actions={actions} className={styles.heading} />
      {desc && <div className={styles.desc}>{desc}</div>}
      <div className={classNames(styles.content, className)}>{children}</div>
    </section>
  );
};

export default Section;
